import { useMutation, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';
import inviteToApplyAPI from 'api/inviteToApplyAPI';
import { InviteToApplyPayload, InviteToApplyResponse } from '../types';

export interface InviteToApplyMutationResponse extends InviteToApplyResponse {
  contact_methods?: string[];
  internal_candidate_note_content?: string;
}

export function useInviteToApplyMutation(
  options: Omit<
    UseMutationOptions<InviteToApplyMutationResponse, unknown, InviteToApplyPayload, unknown>,
    'mutationFn'
  > = {}
): UseMutationResult<InviteToApplyMutationResponse, unknown, InviteToApplyPayload, unknown> {
  return useMutation({
    mutationFn: async (payload) => {
      const response = await inviteToApplyAPI.inviteToApply(payload);

      return {
        candidate_id: response.candidate_id,
        application_id: response.application_id,
        contact_methods: payload.contact_methods,
        internal_candidate_note_content: payload.internal_candidate_note_content,
      };
    },
    ...options,
  });
}
